import { observer } from 'mobx-react';
import moment from 'moment';
import {
    COURSE_BY_STUDENT_STATUS, DATE_YMD, DATE_YMD_ISO,
    SCREEN_MODE, TRAINING_COURSE_SETTINGS_STATUS
} from '../../core/configs/constants';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../core/utils/hook';
import SettingReportModal from './modals/SettingReportModal';
import SettingQuestionModal from './modals/SettingQuestionModal';

const HistoryIcon = () => (
    <svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            fill='#F36D3B'
            d={[
                'M9.39254 2.12357C5.78712 2.0244 2.83338 4.92148 2.83338 8.49857H1.56546C1.24671',
                '8.49857 1.09088 8.88107 1.31754 9.10065L3.29379 11.084C3.43546 11.2256 3.65504',
                '11.2256 3.79671 11.084L5.77296 9.10065C5.82191 9.05071 5.85498 8.98741 5.868',
                '8.91871C5.88103 8.85001 5.87343 8.77899 5.84616 8.7146C5.81889 8.65022 5.77317',
                '8.59534 5.71477 8.5569C5.65636 8.51845 5.58788 8.49816 5.51796 8.49857H4.25004C4.25004',
                '5.73607 6.50254 3.50482 9.27921 3.54023C11.9142 3.57565 14.1313 5.79273 14.1667',
                '8.42773C14.2021 11.1973 11.9709 13.4569 9.20837 13.4569C8.06796 13.4569 7.01254',
                '13.0673 6.17671 12.4086C6.04104 12.3017 5.87081 12.2484 5.69842 12.2589C5.52602',
                '12.2693 5.36348 12.3428 5.24171 12.4652C4.94421 12.7627 4.96546 13.2656 5.29837',
                '13.5206C6.41131 14.4006 7.78958 14.8775 9.20837 14.8736C12.7855 14.8736 15.6825',
                '11.9198 15.5834 8.3144C15.4913 4.99232 12.7146 2.21565 9.39254 2.12357ZM9.03129',
                '5.66523C8.74087 5.66523 8.50004 5.90607 8.50004 6.19648V8.80315C8.50004 9.05107',
                '8.63462 9.28482 8.84712 9.41232L11.0571 10.7227C11.3121 10.8715 11.638 10.7865',
                '11.7867 10.5386C11.9355 10.2836 11.8505 9.95773 11.6025 9.80898L9.56254',
                '8.59773V6.1894C9.56254 5.90607 9.32171 5.66523 9.03129 5.66523Z'
            ].join(' ')}
        />
    </svg>
);

const GridViewIcon = () => (
    <svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            fill='#F36D3B'
            d={[
                'M3.54167 7.79167C3.15208 7.79167 2.81869 7.65307 2.5415 7.37588C2.26431 7.09868',
                '2.12547 6.76506 2.125 6.375V3.54167C2.125 3.15208 2.26383 2.81869 2.5415',
                '2.5415C2.81917 2.26431 3.15256 2.12547 3.54167 2.125H6.375C6.76458 2.125 7.09821',
                '2.26383 7.37588 2.5415C7.65354 2.81917 7.79214 3.15256 7.79167 3.54167V6.375C7.79167',
                '6.76458 7.65307 7.09821 7.37588 7.37588C7.09868 7.65354 6.76506 7.79214 6.375',
                '7.79167H3.54167ZM3.54167 14.875C3.15208 14.875 2.81869 14.7364 2.5415',
                '14.4592C2.26431 14.182 2.12547 13.8484 2.125 13.4583V10.625C2.125 10.2354 2.26383',
                '9.90203 2.5415 9.62483C2.81917 9.34764 3.15256 9.20881 3.54167 9.20833H6.375C6.76458',
                '9.20833 7.09821 9.34717 7.37588 9.62483C7.65354 9.9025 7.79214 10.2359 7.79167',
                '10.625V13.4583C7.79167 13.8479 7.65307 14.1815 7.37588 14.4592C7.09868 14.7369',
                '6.76506 14.8755 6.375 14.875H3.54167ZM10.625 7.79167C10.2354 7.79167 9.90203',
                '7.65307 9.62483 7.37588C9.34764 7.09868 9.20881 6.76506 9.20833 6.375V3.54167C9.20833',
                '3.15208 9.34717 2.81869 9.62483 2.5415C9.9025 2.26431 10.2359 2.12547 10.625',
                '2.125H13.4583C13.8479 2.125 14.1815 2.26383 14.4592 2.5415C14.7369 2.81917 14.8755',
                '3.15256 14.875 3.54167V6.375C14.875 6.76458 14.7364 7.09821 14.4592 7.37588C14.182',
                '7.65354 13.8484 7.79214 13.4583 7.79167H10.625ZM10.625 14.875C10.2354 14.875',
                '9.90203 14.7364 9.62483 14.4592C9.34764 14.182 9.20881 13.8484 9.20833',
                '13.4583V10.625C9.20833 10.2354 9.34717 9.90203 9.62483 9.62483C9.9025 9.34764',
                '10.2359 9.20881 10.625 9.20833H13.4583C13.8479 9.20833 14.1815 9.34717 14.4592',
                '9.62483C14.7369 9.9025 14.8755 10.2359 14.875 10.625V13.4583C14.875 13.8479',
                '14.7364 14.1815 14.4592 14.4592C14.182 14.7369 13.8484 14.8755 13.4583',
                '14.875H10.625ZM3.54167 6.375H6.375V3.54167H3.54167V6.375ZM10.625',
                '6.375H13.4583V3.54167H10.625V6.375ZM10.625 13.4583H13.4583V10.625H10.625',
                'V13.4583ZM3.54167 13.4583H6.375V10.625H3.54167V13.4583Z'
            ].join(' ')}
        />
    </svg>
);

const CheckIcon = () => (
    <svg
        className='ticketplan-check-svg'
        width='20'
        height='16'
        viewBox='0 0 20 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M1.5 8L7.5 14L18.5 1.5'
            stroke='#4EA953'
            strokeWidth='2.8'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

const CompletedCourseTab = observer(({ lstTrainingCourseGroupedByTicketPlans, fetchData }) => {
    const { courseStore: { issueCompletionCertificate } } = useStore();

    const hasAnyCompleted = lstTrainingCourseGroupedByTicketPlans?.some(group =>
        group.courses?.some(c =>
            COURSE_BY_STUDENT_STATUS.USER_COURSE_COMPLETE.value.includes(c.statusUserCourse)
        )
    );

    if (!hasAnyCompleted) {
        return (
            <div className='completed-training-course-tab'>
                <div className='d-flex align-items-center justify-content-center min-height-200'>
                    データはありません
                </div>
            </div>
        );
    }

    return (
        <div className='completed-training-course-tab'>
            {lstTrainingCourseGroupedByTicketPlans?.map((group, groupIndex) => {
                const completedCourses = (group.courses || []).filter(c =>
                    COURSE_BY_STUDENT_STATUS.USER_COURSE_COMPLETE.value.includes(c.statusUserCourse)
                );
                if (completedCourses.length === 0) return null;

                return (
                    <div key={groupIndex} className='ticketplan-group'>
                        <div className='ticketplan-group-header'>
                            <span className='ticketplan-group-name'>
                                <CheckIcon />
                                {group.name}
                            </span>
                            {group.canIssueCertificate && (
                                <button
                                    className='btn-issue-certificate'
                                    onClick={() => issueCompletionCertificate(group.id)}
                                >
                                    修了証
                                </button>
                            )}
                        </div>
                        {completedCourses.map((course, index) => (
                            <CompletedTrainingCourseItem
                                key={index}
                                id={course.id}
                                name={course.name}
                                completionDate={course.completionDate}
                                recentlyTestResult={course.recentlyTestResult}
                                reportContent={course.reportContent}
                                isDownloaded={course.isDownloaded}
                                reportDate={course.reportDate}
                                submitReportDeadline={course.submitReportDeadline}
                                reportMaxLength={course.reportMaxLength}
                                submitReportStatus={course.submitReportStatus}
                                submitQuestionStatus={course.submitQuestionStatus}
                                question={course.question}
                                questionDate={course.questionDate}
                                submitQuestionDeadline={course.submitQuestionDeadline}
                                fetchData={fetchData}
                            />
                        ))}
                    </div>
                );
            })}
        </div>
    );
});

const CompletedTrainingCourseItem = ({
    id,
    name,
    completionDate,
    recentlyTestResult,
    reportContent,
    reportDate,
    submitReportDeadline,
    submitReportStatus,
    reportMaxLength,
    submitQuestionStatus,
    question,
    questionDate,
    isDownloaded,
    submitQuestionDeadline,
    fetchData
}) => {
    const navigate = useNavigate();
    const { modalStore: { show, hide } } = useStore();

    const navigateTestResultHistory = () => {
        navigate(`/test-result-history/${id}`);
    }

    const navigateCourseDetail = () => {
        navigate(`/course/${id}`);
    }

    const isDeadlineActive = (deadline) =>
        deadline && moment(deadline).isSameOrAfter(moment().format(DATE_YMD_ISO));

    const handleShowModalSettingReport = (courseId, courseName, deadline, mode, content) => {
        show({
            id: 'modal-setting-submit-report-training-course',
            isOpen: true,
            header: '提出物アップロード',
            onCancel: () => hide(),
            children: (
                <SettingReportModal
                    mode={mode}
                    id={courseId}
                    name={courseName}
                    deadline={deadline}
                    fetchData={fetchData}
                    reportContent={content}
                    reportMaxLength={reportMaxLength}
                    readOnly={content && (
                        submitReportStatus === TRAINING_COURSE_SETTINGS_STATUS.OFF
                        || mode === SCREEN_MODE.VIEW
                    )}
                />
            ),
            type: 'medium width-850 responsive-modal'
        });
    }

    const handleShowModalSettingQuestion = (mode) => {
        show({
            id: 'modal-setting-submit-question-training-course',
            isOpen: true,
            header: mode === SCREEN_MODE.ADD ? '質問する' : '質問',
            onCancel: () => hide(),
            children: (
                <SettingQuestionModal
                    mode={SCREEN_MODE.EDIT}
                    id={id}
                    name={name}
                    deadline={submitReportDeadline}
                    fetchData={fetchData}
                    question={question}
                    readOnly={question && questionDate}
                />
            ),
            type: 'medium width-750 responsive-modal'
        });
    }

    const renderReportAction = () => {
        if (reportContent) {
            if (submitReportDeadline && !isDownloaded && isDeadlineActive(submitReportDeadline)) {
                return (
                    <div
                        className='text-link text-hover-underline cursor-pointer'
                        onClick={() => handleShowModalSettingReport(
                            id, name, submitReportDeadline, SCREEN_MODE.EDIT, reportContent
                        )}
                    >
                        修正する
                    </div>
                );
            }
            return (
                <div
                    className='text-link text-hover-underline cursor-pointer'
                    onClick={() => handleShowModalSettingReport(
                        id, name, submitReportDeadline, SCREEN_MODE.VIEW, reportContent
                    )}
                >
                    提出済
                </div>
            );
        }
        if (isDeadlineActive(submitReportDeadline)) {
            return (
                <div
                    className='text-link text-hover-underline cursor-pointer'
                    onClick={() => handleShowModalSettingReport(
                        id, name, submitReportDeadline, SCREEN_MODE.ADD
                    )}
                >
                    提出する
                </div>
            );
        }
        return (
            <div className='text-danger' style={{ fontWeight: '500', fontSize: '14px' }}>
                期限切れ
            </div>
        );
    }

    const hasContent = submitReportStatus === TRAINING_COURSE_SETTINGS_STATUS.ON
        || submitQuestionStatus === TRAINING_COURSE_SETTINGS_STATUS.ON;

    return (
        <div className='completed-training-course-item'>
            <div className='header'>
                <div className='header-info'>
                    <div
                        className='header-info-name line-clamp-1'
                        style={{ wordBreak: 'break-all' }}
                    >
                        {name}
                    </div>
                    <div className='header-info-desc'>
                        <div className='header-info-completion-date'>
                            {`受講完了日: ${completionDate ? moment(completionDate).format(DATE_YMD) : ''}`}
                        </div>
                        {recentlyTestResult != null && (
                            <div className='header-info-currently-test'>
                                {`テスト結果: ${recentlyTestResult}%`}
                            </div>
                        )}
                    </div>
                </div>
                <div className='header-button'>
                    <button className='second-btn' onClick={navigateTestResultHistory}>
                        <HistoryIcon />
                        テスト結果履歴
                    </button>
                    <button className='primary-btn' onClick={navigateCourseDetail}>
                        <GridViewIcon />
                        詳細を見る
                    </button>
                </div>
            </div>
            {hasContent && (
                <div className='content'>
                    {submitReportStatus === TRAINING_COURSE_SETTINGS_STATUS.ON && (
                        <>
                            <div className='content-item'>
                                <span className='content-item-header'>レポート</span>
                                <div className='content-item-desc'>
                                    {renderReportAction()}
                                </div>
                            </div>
                            <div className='content-item'>
                                <span className='content-item-header'>提出期限</span>
                                <div className='content-item-desc'>
                                    <span>
                                        {submitReportDeadline
                                            ? moment(submitReportDeadline).format(DATE_YMD) : '--'}
                                    </span>
                                    {!isDeadlineActive(submitReportDeadline) && (
                                        <span className='text-danger fw-bold'> (期限切れ)</span>
                                    )}
                                </div>
                            </div>
                            <div className='content-item'>
                                <span className='content-item-header'>提出物の提出日</span>
                                <div className='content-item-desc'>
                                    {reportDate ? moment(reportDate).format(DATE_YMD) : '--'}
                                </div>
                            </div>
                        </>
                    )}
                    {submitQuestionStatus === TRAINING_COURSE_SETTINGS_STATUS.ON && (
                        <>
                            <div className='content-item'>
                                <span className='content-item-header'>質問</span>
                                <div className='content-item-desc'>
                                    {!question && (
                                        isDeadlineActive(submitQuestionDeadline) ? (
                                            <span
                                                className='text-link text-hover-underline cursor-pointer'
                                                onClick={() => handleShowModalSettingQuestion(
                                                    SCREEN_MODE.ADD
                                                )}
                                            >
                                                質問する
                                            </span>
                                        ) : (
                                            <span className='text-danger'>期限切れ</span>
                                        )
                                    )}
                                    {question && questionDate && (
                                        <span>
                                            質問済 (
                                            <span
                                                className='text-link text-hover-underline cursor-pointer'
                                                onClick={() => handleShowModalSettingQuestion(
                                                    SCREEN_MODE.EDIT
                                                )}
                                            >
                                                詳細を見る
                                            </span>
                                            )
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className='content-item'>
                                <span className='content-item-header'>質問可能な期限</span>
                                <div className='content-item-desc'>
                                    {submitQuestionDeadline
                                        ? moment(submitQuestionDeadline).format(DATE_YMD) : '--'}
                                    {!isDeadlineActive(submitQuestionDeadline) && (
                                        <span className='text-danger fw-bold'> (期限切れ)</span>
                                    )}
                                </div>
                            </div>
                            <div className='content-item'>
                                <span className='content-item-header'>質問日</span>
                                <div className='content-item-desc'>
                                    {questionDate ? moment(questionDate).format(DATE_YMD) : '--'}
                                </div>
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
}

export default CompletedCourseTab;
